import { __awaiter, __generator } from "tslib";
export var createDeprecatedLinkButtonDriver = function (wrapper) {
    var base = wrapper.$(".deprecated-link-button");
    return {
        click: function () { return base.click(); },
        getText: function () { return base.text(); },
        isDisabled: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.hasClass('disabled')];
        }); }); }
    };
};
//# sourceMappingURL=driver.js.map